
    <a href="mailto:admin@riseupcanada.ca" target="_top"><span class="social-media-icons"><i class="mdi mdi-email"></i></span></a>
    <a href="https://www.facebook.com/riseupcanada.ca" target="_blank"><span class="social-media-icons"><i class="mdi mdi-facebook-box"></i></span></a>
    <a href="https://www.youtube.com/channel/UCsvlUcixJEwbjrdQcbY52sA" target="_blank"><span class="social-media-icons"><i class="mdi mdi-youtube-play"></i></span></a>
    <a href="https://twitter.com/riseupcan" target="_blank"><span class="social-media-icons"><i class="mdi mdi-twitter-box"></i></span></a>

